// extracted by mini-css-extract-plugin
module.exports = {"footer":"ZenViewGridLess-ZenViewGridLess-footer-097ca824"};